export default class DtmfPlayer {
  /**
   * These are default frequencies which are the exact frequencies for DTMF signaling
   * They are saved as a comment for a reference
   * frequencies = {
   *   '1': { freq1: 697, freq2: 1209 },
   *   '2': { freq1: 697, freq2: 1336 },
   *   '3': { freq1: 697, freq2: 1477 },
   *   '4': { freq1: 770, freq2: 1209 },
   *   '5': { freq1: 770, freq2: 1336 },
   *   '6': { freq1: 770, freq2: 1477 },
   *   '7': { freq1: 852, freq2: 1209 },
   *   '8': { freq1: 852, freq2: 1336 },
   *   '9': { freq1: 852, freq2: 1477 },
   *   '*': { freq1: 941, freq2: 1209 },
   *   '0': { freq1: 941, freq2: 1336 },
   *   '#': { freq1: 941, freq2: 1477 },
   * }
   */

  frequencies = {
    '1': { freq1: 380, freq2: 1550 },
    '2': { freq1: 405, freq2: 1625 },
    '3': { freq1: 430, freq2: 1700 },
    '4': { freq1: 455, freq2: 1550 },
    '5': { freq1: 480, freq2: 1625 },
    '6': { freq1: 505, freq2: 1700 },
    '7': { freq1: 530, freq2: 1550 },
    '8': { freq1: 555, freq2: 1625 },
    '9': { freq1: 580, freq2: 1700 },
    '*': { freq1: 605, freq2: 1550 },
    '0': { freq1: 630, freq2: 1625 },
    '#': { freq1: 655, freq2: 1700 },
  }

  oscillator1 = null

  oscillator2 = null

  audioContext = null

  timeoutDuration = 1000

  timeout

  constructor() {
    const ContextClass =
      window.AudioContext ||
      window.webkitAudioContext ||
      window.mozAudioContext ||
      window.oAudioContext ||
      window.msAudioContext

    if (ContextClass) {
      this.audioContext = new ContextClass()
    }
  }

  playTone = ({ freq1, freq2 }) => {
    this.stop()

    const gainNode = this.audioContext.createGain()
    gainNode.gain.value = 0.1

    this.oscillator1 = this.audioContext.createOscillator()
    this.oscillator1.type = 'sine'
    this.oscillator1.frequency.value = freq1
    this.oscillator1.connect(gainNode, 0, 0)
    gainNode.connect(this.audioContext.destination)

    this.oscillator2 = this.audioContext.createOscillator()
    this.oscillator2.type = 'sine'
    this.oscillator2.frequency.value = freq2
    this.oscillator2.connect(gainNode)
    gainNode.connect(this.audioContext.destination)

    this.oscillator1.start(0)
    this.oscillator2.start(0)

    // don't ring indefinitely
    this.timeout = setTimeout(this.stop, this.timeoutDuration)
  }

  play = (key) => {
    const frequency = this.frequencies[String(key)]
    frequency && this.playTone(frequency)
  }

  stop = () => {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    if (this.oscillator1 !== null) {
      this.oscillator1.disconnect()
    }
    if (this.oscillator2 !== null) {
      this.oscillator2.disconnect()
    }
  }

  async close() {
    if (this.audioContext) {
      await this.audioContext.close()
    }
  }
}
